module.exports = "/_next/static/images/ico-search-16900bb33cbcb47a73d803c27bbaecff.svg";